import * as React from "react";
import "./CustomCardDashboard.scss";
import { IconInfo } from "../../../../../assets/index";
import { formatMoney, isEmpty } from "../../../../../utils/helpers/helpers";
import { Button, Tooltip } from "antd";
import { routes } from "../../../../../utils/constants/constant";
import { useHistory } from "react-router-dom";

const CustomCardDashboard = (props) => {
  const { userAffiliationInfo } = props;
  const history = useHistory();
  return (
    <div className="custom-card-dashboard">
      <div className="body-card-dashboard">
        <div className="title-text-dashboard">Thu nhập</div>
        <div className="row-current-balance">
          Số dư hiện tại{" "}
          <Tooltip placement="top" title="Hoa Hồng chưa thanh toán" style={{}}>
            <IconInfo style={{ marginLeft: 4 }} />
          </Tooltip>
        </div>
        <div className="money-text">
          {!isEmpty(userAffiliationInfo?.currentCommission)
            ? formatMoney(userAffiliationInfo?.currentCommission)
            : "0"}
        </div>
        <div className="normal-text">VND</div>
        <div className="row-current-balance">
          Lượt thanh toán gần nhất
          <Tooltip
            placement="top"
            title="Bạn cần đạt tối thiểu 50.000đ hoa hồng để được thanh toán vào tài khoản ngân hàng"
            style={{}}
          >
            <IconInfo style={{ marginLeft: 4 }} />
          </Tooltip>
        </div>
        <div className="horizon">
          {!isEmpty(userAffiliationInfo?.lastCommission)
            ? formatMoney(userAffiliationInfo?.lastCommission)
            : "-"}
        </div>{" "}
        <div className="normal-text">VND</div>
        <Button
          type="text"
          className="see-detail-text"
          onClick={() => history?.push(`${routes.INCOME_DETAIL}`)}
        >
          Xem chi tiết
        </Button>
      </div>
    </div>
  );
};

export default CustomCardDashboard;
